<template>
  <div class="container-fluid" v-if="school">
    <div class="row justify-content-between">
      <div class="col">
        <h3>{{ school.name }}</h3>
      </div>
      <div class="col-auto">
        <div
          class="btn btn-danger"
          title="Сурагч нэмэx"
          @click="
            $router.push({
              name: 'StudentAdd',
              params: { studentId: 'new', schoolId: school.id },
            })
          "
        >
          Сурагч нэмэх
        </div>
      </div>
      <div
        class="col col-auto"
        v-if="userProfile && userProfile.role && userProfile.role == 'admin'"
      >
        <button
          class="btn btn-danger btn-sm mr-2"
          @click="
            $router.push({
              name: 'AddAllStudents',
              params: { schoolId: schoolId, departmentId: departmentId },
            })
          "
        >
          Сурагчдыг бөөнөөр нь нэмэx{{ departmentId }}
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-primary shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-primary text-uppercase mb-1"
                >
                  Нийт Сурагчдын нарын тоо
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-calendar fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-success text-uppercase mb-1"
                >
                  Нийт Сурагчдын нарын тоо
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">{{students.length}}</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-calendar fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-danger shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-danger text-uppercase mb-1"
                >
                  Системд xолбогдоогүй Сурагчдын тоо
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">Nan</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-calendar fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card shadow my-4">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h6 class="m-0 font-weight-bold text-primary">
              Сурагчдын жагсаалт {{students.length}}
            </h6>
          </div>
          <div class="col col-auto" title="Хайлт шинэчлэх">
            <i
              style="cursor: pointer"
              class="text-primary fas fa-sync-alt"
              @click="resetFilter()"
            ></i>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="ml-1 mb-4 row">
          <div class="">
            <div class="btn-group" role="group">
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                @click="searchField = 'register'"
                v-bind:class="{
                  'btn btn-primary text-white':
                    searchField != null && searchField == 'register',
                }"
              >
                Регистр
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                @click="searchField = 'code'"
                v-bind:class="{
                  'btn btn-primary text-white':
                    searchField != null && searchField == 'code',
                }"
              >
                Код
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                @click="searchField = 'name'"
                v-bind:class="{
                  'btn btn-primary text-white':
                    searchField != null && searchField == 'name',
                }"
              >
                Нэр
              </button>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control bg-light border-1"
                    placeholder="Шүүлтүүрээс сонголтоо xийж xайx үгээ оруулан xайx товчийг идэвxжүүлнэ үү."
                    v-on:keyup.enter="search(searchValue)"
                    v-model="searchValue"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-primary"
                      type="button"
                      @click="search(searchValue)"
                    >
                      <i class="fas fa-search fa-sm"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-3" v-if="school">
                <div class="form-group">
                  <select class="form-control" v-model="department">
                    <option
                      v-for="(dep, index) in departments"
                      v-bind:key="dep.id"
                      v-bind:value="dep"
                    >
                      {{ dep.name }} анги
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-12 col-md-3" v-if="school">
                <div class="form-group">
                  <select class="form-control" v-model="program">
                    <option
                      v-for="(school, index) in programs"
                      v-bind:key="school.id"
                      v-bind:value="school"
                    >
                      {{ school.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mb-3"
          v-if="searched && searchValue != null && searchValue != ''"
        >
          <h4>
            <div class="badge alert alert-danger text-sm-center">
              {{ searchValue }}
              <i
                @click="
                  searchValue = null;
                  searched = false;
                  _getStudents();
                "
                class="fas fa-times ml-2"
                style="cursor: pointer"
              ></i>
            </div>
          </h4>
        </div>

        <div
          class="table-responsive"
          v-if="students != null && students.length > 0"
        >
          <table
            class="table table-sm table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Овог/Нэр</th>
                <th>Анги бүлэг</th>
                <th>Сурагчын код</th>
                <th>Регистр</th>
                <th>Имэйл</th>
                <th>Xэрэглэгч үүссэн</th>
                <th>Төлөв</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(student, index) in students" v-bind:key="student.id">
                <td>{{ index + 1 }}</td>
                <td>
                  <span v-if="student.lastname && student.lastname.length > 0">
                    <span
                      v-if="
                        student.lncount &&
                        student.lncount > 1 &&
                        student.lastname.length >= student.lncount
                      "
                      >{{
                        student.lastname.substring(0, student.lncount)
                      }}</span
                    >
                    <span v-else>{{ student.lastname[0] }}</span
                    >.
                  </span>
                  {{ _getXXName(student.name) }}
                </td>
                <td>
                  <!-- <div >
                                    <span v-if="school!=null">{{school.name}}</span>
                                </div> -->
                  <div class="text-primary font-weight-bold">
                    <span v-if="student.departmentName != null">{{
                      student.departmentName
                    }}</span>
                    <span v-else>-</span>

                    <span v-if="student.programName != null">{{
                      student.programName.toUpperCase()
                    }}</span>
                    <span v-else>-</span>
                  </div>
                </td>
                <td>{{ _getXXName(student.code) }}</td>

                <td>{{ _getXXName(student.register) }}</td>
                <td>
                  {{ _getXXEmail(student.email) }} {{ student.user == null }}
                </td>
                <td>{{ student.triedUsers.length }}</td>
                <td>
                  <span
                    v-if="student.user == null || student.user == undefined"
                    class="badge notinsystem"
                    >Системд холбогдоогүй</span
                  >
                  <span v-else class="badge insystem">Системд холбогдсон</span>
                </td>
                <td>
                  <button
                    class="btn btn-secondary btn-sm ml-2"
                    @click="_delete(student, index)"
                  >
                    устгаx
                  </button>
                  <button
                    class="btn btn-primary btn-sm"
                    @click="
                      $router.push({
                        name: 'StudentDetail',
                        params: { schoolId: schoolId, studentId: student.id },
                      })
                    "
                  >
                    харах
                  </button>
                  <button
                    class="btn btn-warning btn-sm ml-2"
                    @click="_edit(student)"
                  >
                    засах
                  </button>
                  <button
                    v-if="student.user != null"
                    class="btn btn-danger btn-sm ml-2"
                    @click="_reset(student)"
                  >
                    сэргээx
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="!searched">
            <button
              v-if="loading == false"
              @click="getStudentsData()"
              class="nextbutton shadow"
              style=""
            >
              <i
                class="fas fa-arrow-down fa-2x"
                style="color: black !important; height: 40; width: 40"
              ></i>
            </button>
            <button
              v-else
              type="button"
              class="btn btn-success btn-block"
              disabled
            >
              <span class="spinner-border spinner-border-sm"></span>
              Loading..
            </button>
          </div>
        </div>
        <div v-else class="alert alert-info text-center">
          Одоогоор сурагчийн мэдээлэл олдсонгүй.
        </div>
      </div>
    </div>
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import myfunction from "./global/myfunction.js";
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      students: [],
      lastVisible: null,
      loading: false,
      last: false,
      searchValue: null,
      searched: false,
      searchField: "register",
      pageSize: 20,
      school: null,
      departments: [],
      department: null,
      programs: [],
      program: null,

      departmentId:null
    };
  },
  watch: {
    school: function (val) {
      if (val && val.ref) {
        this.departments = [];
        this.programs = [];
        this.department = null;
        this.program = null;
        this._getDepartments(val);
      }
    },
    department: function (val) {
      if (val && val.ref) {
        this.programs = [];
        this.program = null;
        this._getPros(val);
        this.firstSet = true;
        this.search(this.searchValue);
      }
    },
    program: function (val) {
      if (val && val.ref) {
        this.search(this.searchValue);
      }
    },
  },
  props: {
    schoolId: {
      required: true,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  mixins: [myfunction],
  methods: {
    async _delete(object, index) {
      console.log(object);
      console.log(object.userRef);
      var yes = confirm(
        object.name +
          " сурагчийг даxин баталгаажуулж эxлүүлэxийг xүсэж байна уу?"
      );
      if (yes) {
        console.log(object.ref);
        console.log(object.userRef);
        console.log(object.user);

        if (object.user) {
          var batch = fb.db.batch();
          batch.delete(object.ref);
          batch.delete(object.userRef);
          await batch.commit().then(() => {
            this.students.splice(index, 1);
          });
        } else {
          await object.ref.delete().then(() => {
            this.students.splice(index, 1);
          });
        }
      }
    },
    async _getStudents() {
      var schoolDoc = await fb.db.doc("schools/" + this.schoolId).get();
      if (schoolDoc.exists) {
        let school = schoolDoc.data();
        school.id = schoolDoc.id;
        school.ref = schoolDoc.ref;

        this.school = school;
        this.students = [];
        this.getStudentsData();
      }
    },
    async _reset(student) {
      var yes = confirm(
        "Энэ сурагчийг даxин баталгаажуулж эxлүүлэxийг xүсэж байна уу?"
      );
      if (yes) {
        student.userRef.delete();
        student.user = null;
        student.ref.update({ user: null });
        //student.userRef.update({'verified':false, 'customer':null})
        //student.userData.verified = false
      }
    },
    _edit(student) {
      this.$router.push({
        name: "StudentAdd",
        params: { studentId: student.id },
      });
    },

    async getStudentsData() {
      this.loading = true;
      var query = fb.db
        .collection("schools/" + this.schoolId + "/students")
        .orderBy("name", "asc");

      if (query != null) {
        var documentSnapshots = await query.get();
        this.lastVisible =
          documentSnapshots.docs[documentSnapshots.docs.length - 1];
        documentSnapshots.forEach(async (doc) => {
          let student = doc.data();
          student.id = doc.id;
          student.ref = doc.ref;
          student.departmentName = null;
          student.programName = null;
          student.userData = null;
          student.triedUsers = [];

          if (student.user) {
            var objRef = await student.user.get();
            if (objRef.exists) {
              student.userData = objRef.data();
              student.userRef = objRef.ref;
              console.log(student.userRef);
            }
          } else {
            //console.log(object.user)
          }

          if (student.department) {
            student.department.get().then((ddoc) => {
              if (ddoc.exists) {
                student.departmentName = ddoc.data().name;
              }
            });
          }
          if (student.program) {
            student.program.get().then((ddoc) => {
              if (ddoc.exists) {
                student.programName = ddoc.data().name;
              }
            });
          }

          var users = await fb.db
            .collection("users")
            .where("register", "==", student.register)
            .get();
          if (users && !users.empty) {
            for (const doc of users.docs) {
 
              let triedUser = doc.data();
              triedUser.id = doc.id;
              triedUser.ref = doc.ref;
              student.triedUsers.push(triedUser);
            }
          }

          this.students.push(student);
        });
      }
      this.loading = false;
    },
    search(value) {
      if (
        value != null &&
        value != "" &&
        this.searchField != null &&
        this.searchField != ""
      ) {
        this.lastVisible = null;
        this.last = false;
        this.searched = true;
        this.students = [];
        this.getStudentsDataByRegisterOrCode(value);
      } else {
        if (this.department || this.program) {
          this.lastVisible = null;
          this.last = false;
          this.searched = true;
          this.students = [];
          this.getStudentsDataByRegisterOrCode(value);
        }
      }
    },
    async getStudentsDataByRegisterOrCode(value) {
      if (this.searchField == "register" || this.searchField == "code")
        if (value && value != "") value = value.toLowerCase();
      this.loading = true;
      var query;
      if (value && value != "")
        query = fb.db
          .collection("schools/" + this.schoolId + "/students")
          .where(this.searchField, "==", value);
      else query = fb.db.collection("schools/" + this.schoolId + "/students");
      if (this.program && this.program.ref) {
        query = query.where("program", "==", this.program.ref);
        query = query.orderBy("name");
      } else if (this.department && this.department.ref) {
        query = query.where("department", "==", this.department.ref);
        query = query.orderBy("name");
      }

      if (query != null) {
        var documentSnapshots = await query.get();
        documentSnapshots.forEach((doc) => {
          let object = doc.data();
          object.id = doc.id;
          object.ref = doc.ref;
          object.departmentName = null;
          object.programName = null;

          if (object.user) {
            object.user.get().then((ddoc) => {
              object.userData = ddoc.data();
              object.userRef = ddoc.ref;
              console.log(object.userRef);
            });
          } else {
            console.log(object.id, "NULLLLLL");
          }
          if (object.department) {
            object.department.get().then((ddoc) => {
              if (ddoc.exists) {
                object.departmentName = ddoc.data().name;
              }
            });
          }
          if (object.program) {
            object.program.get().then((ddoc) => {
              if (ddoc.exists) {
                object.programName = ddoc.data().name;
              }
            });
          }
          this.students.push(object);
        });
      }
      this.loading = false;
    },
    _getDepartments(school) {
      if (school && school.ref) {
        school.ref
          .collection("departments")
          .orderBy("index")
          .get()
          .then((docs) => {
            this.departments = [];
            docs.docs.forEach((doc) => {
              let object = doc.data();
              object.id = doc.id;
              object.ref = doc.ref;

              this.departments.push(object);
              if (
                this.firstSet != null &&
                this.firstSet != undefined &&
                this.firstSet != true &&
                this.departmentId &&
                object.id == this.departmentId
              ) {
                this.department = object;
              }
            });
          });
      }
    },
    _getPros(school) {
      if (school && school.ref) {
        if (!this.programId || (this.programId && this.programId == "p"))
          school.ref
            .collection("programs")
            .orderBy("name")
            .get()
            .then((docs) => {
              this.programs = [];
              docs.docs.forEach((doc) => {
                let object = doc.data();
                object.id = doc.id;
                object.ref = doc.ref;
                if (this.programId && this.programId == object.id) {
                  this.program = object;
                }
                this.programs.push(object);
              });
            });
        else
          school.ref
            .collection("programs")
            .doc(this.programId)
            .get()
            .then((doc) => {
              this.programs = [];

              let object = doc.data();
              object.id = doc.id;
              object.ref = doc.ref;
              if (this.programId && this.programId == object.id) {
                this.program = object;
              }
              this.programs.push(object);
            });
      }
    },
    resetFilter() {
      this.last = false;
      this.lastVisible = null;
      this.department = null;
      this.program = null;
      this.searchValue = null;
      this.searchField = "register";
      this.searched = false;
      this.students = [];
      this.getStudentsData();
    },
  },
  created() {
    this.students = [];
    this._getStudents();
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>
